let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fzaBp")).then(() => parcelRequire('kUi3j'));